export default function Footer() {
  const footerLinks = [
    {
      title: '追剧导航',
      links: [
        { label: '追剧索引', href: '#index' },
        { label: '精选专题', href: '#carousel' },
        { label: '热度榜单', href: '#ranking' },
        { label: '精彩推荐', href: '#cards' },
        { label: '精彩片段', href: '#media' },
      ],
    },
    {
      title: '帮助中心',
      links: [
        { label: '常见问题', href: '#faq' },
        { label: '最新动态', href: '#updates' },
        { label: '热门话题', href: '#topics' },
        { label: '平台特色', href: '#features' },
        { label: '关于我们', href: '#about' },
      ],
    },
    {
      title: '联系互动',
      links: [
        { label: '联系我们', href: '#contact' },
        { label: '移动追剧', href: '#app' },
        { label: '观众热评', href: '#comments' },
      ],
    },
    {
      title: '合作伙伴',
      links: [],
    },
  ];

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const el = document.getElementById(id.replace('#', ''));
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          {footerLinks.map((group, idx) => (
            <div key={idx}>
              <h4 className="font-heading text-base md:text-lg text-background-50 mb-4">
                {group.title}
              </h4>
              {group.links.length > 0 ? (
                <ul className="space-y-2.5">
                  {group.links.map((link, li) => (
                    <li key={li}>
                      <a
                        href={link.href}
                        onClick={(e) => handleClick(e, link.href)}
                        className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-sm text-background-500">虚位以待</p>
              )}
            </div>
          ))}
        </div>

        <div className="border-t border-background-800/60 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2.5">
            <span className="w-8 h-8 rounded-lg bg-primary-600 flex items-center justify-center">
              <i className="ri-movie-2-fill text-background-50"></i>
            </span>
            <span className="font-heading text-base text-background-100">夜猫影院</span>
          </div>

          <p className="text-xs text-background-500 text-center">
            夜猫影院提供最新电视剧全集、热播剧完整版高清免费在线观看，熬夜追剧不缓冲，全集免费看。本平台内容仅供学习交流，版权归原作者所有。
          </p>

          <p className="text-xs text-background-600 whitespace-nowrap">
            &copy; {new Date().getFullYear()} 夜猫影院
          </p>
        </div>
      </div>
    </footer>
  );
}